const shopMapping = {
  
  "SHOPPING_TIJUCA": "VITE_ID_SHOPPING_TIJUCA",
  "SHOPPING_BANGU": "VITE_ID_SHOPPING_BANGU",
  "SHOPPING_GRANDE_RIO": "VITE_ID_SHOPPING_GRANDE_RIO",
  "SHOPPING_PARQUE_D_PEDRO": "VITE_ID_SHOPPING_PARQUE_D_PEDRO",
  "SHOPPING_CAXIAS": "VITE_ID_SHOPPING_CAXIAS",
  "SHOPPING_NORTE": "VITE_ID_SHOPPING_NORTE",
  "SHOPPING_VILA_VELHA": "VITE_ID_SHOPPING_VILA_VELHA",
  "SHOPPING_PARANGABA": "VITE_ID_SHOPPING_PARANGABA",
  "SHOPPING_DA_BAHIA": "VITE_ID_SHOPPING_DA_BAHIA",
  "SHOPPING_DEL_REY": "VITE_ID_SHOPPING_DEL_REY",
  "SHOPPING_BOULEVARD_BH": "VITE_ID_SHOPPING_BOULEVARD_BH",
  "SHOPPING_ESTACAO_BH": "VITE_ID_SHOPPING_ESTACAO_BH",
  "SHOPPING_PLAZA_NITEROI": "VITE_ID_SHOPPING_PLAZA_NITEROI",
  "SHOPPING_TABOAO": "VITE_ID_SHOPPING_TABOAO",
  "SHOPPING_CARIOCA": "VITE_ID_SHOPPING_CARIOCA",
  "SHOPPING_CAMPO_LIMPO": "VITE_ID_SHOPPING_CAMPO_LIMPO",
  "SHOPPING_PASSEIO_DAS_AGUAS": "VITE_ID_SHOPPING_PASSEIO_DAS_AGUAS",
  "SHOPPING_LEBLON": "VITE_ID_SHOPPING_LEBLON",
  "SHOPPING_MOOCA_PLAZA": "VITE_ID_SHOPPING_MOOCA_PLAZA",
  "SHOPPING_CENTER_UBERLANDIA": "VITE_ID_SHOPPING_CENTER_UBERLANDIA",
  "SHOPPING_PLAZA_SUL": "VITE_ID_SHOPPING_PLAZA_SUL",
  "SHOPPING_PIRACICABA": "VITE_ID_SHOPPING_PIRACICABA",
  "SHOPPING_TAMBORE": "VITE_ID_SHOPPING_TAMBORE",
  "SHOPPING_BOULEVARD_BELEM": "VITE_ID_SHOPPING_BOULEVARD_BELEM",
  "SHOPPING_ESTACAO_CUIABA": "VITE_ID_SHOPPING_ESTACAO_CUIABA",
  "SHOPPING_CARIRI": "VITE_ID_SHOPPING_CARIRI",
  "SHOPPING_INDEPENDENCIA": "VITE_ID_SHOPPING_INDEPENDENCIA",
  "SHOPPING_CATUAI_MARINGA": "VITE_ID_SHOPPING_CATUAI_MARINGA",
  "SHOPPING_CAMPO_GRANDE": "VITE_ID_SHOPPING_CAMPO_GRANDE",
  "SHOPPING_VILLA_LOBOS": "VITE_ID_SHOPPING_VILLA_LOBOS",
  "SHOPPING_CATUAI_LONDRINA": "VITE_ID_SHOPPING_CATUAI_LONDRINA",
  "SAO_BERNARDO_PLAZA_SHOPPING": "VITE_ID_SAO_BERNARDO_PLAZA_SHOPPING",
  "SHOPPING_VILLAGIO_CAXIAS": "VITE_ID_SHOPPING_VILLAGIO_CAXIAS",
  "MANAUARA_SHOPPING": "VITE_ID_MANAUARA_SHOPPING",
  "GOIANIA_SHOPPING": "VITE_ID_GOIANIA_SHOPPING",
  "RECREIO_SHOPPING": "VITE_ID_RECREIO_SHOPPING",
  "AMAZONAS_SHOPPING": "VITE_ID_AMAZONAS_SHOPPING",
  "PARQUE_SHOPPING_BELEM": "VITE_ID_PARQUE_SHOPPING_BELEM",
  "FRANCA_SHOPPING": "VITE_ID_FRANCA_SHOPPING",
  "SHOPPING_CURITIBA": "VITE_ID_SHOPPING_CURITIBA",
  "RIO_ANIL_SHOPPING": "VITE_ID_RIO_ANIL_SHOPPING",
  "SHOPPING_METRO_SANTA_CRUZ": "VITE_ID_SHOPPING_METRO_SANTA_CRUZ",
  "SHOPPING_METROPOLE": "VITE_ID_SHOPPING_METROPOLE",
  "SHOPPING_BOULEVARD_FEIRA_DE_SANTANA": "VITE_ID_SHOPPING_BOULEVARD_FEIRA_DE_SANTANA",

};

export default shopMapping;


